import { useEffect, useState } from "react";
import api, { formatBRL } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { workdaysRemaining } from "@/lib/workdays";
import { Target } from "lucide-react";

export default function HeaderCountdown() {
  const { user } = useAuth() || {};
  const [now, setNow] = useState(new Date());
  const [meta, setMeta] = useState(null);

  useEffect(() => {
    const t = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(t);
  }, []);

  useEffect(() => {
    if (!user) return;
    const load = () => api.get("/dashboards/meta-usuario").then((r) => setMeta(r.data)).catch(() => {});
    load();
    const t = setInterval(load, 60000);
    return () => clearInterval(t);
  }, [user]);

  if (!user) return null;

  const dias = workdaysRemaining(now);
  const hhmmss = now.toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit", second: "2-digit" });
  const falta = meta ? Math.max(0, meta.falta) : 0;

  return (
    <div className="hidden md:flex items-center gap-3 pr-2" data-testid="header-countdown">
      <div className="flex flex-col items-end leading-tight">
        <div className="font-display text-lg font-bold tabular-nums text-slate-900" data-testid="header-clock">
          {hhmmss}
        </div>
        {meta && !meta.meta && (
          <div className="text-[11px] text-slate-500 flex items-center gap-1" data-testid="header-meta">
            <Target className="w-3 h-3 text-amber-500" />
            faltam <b className="text-slate-800">{dias}</b> {dias === 1 ? "dia útil" : "dias úteis"} · sem meta cadastrada no mês
          </div>
        )}
        {meta && !!meta.meta && (
          <div className="text-[11px] text-slate-500 flex items-center gap-1" data-testid="header-meta">
            <Target className="w-3 h-3 text-amber-500" />
            faltam <b className="text-slate-800">{dias}</b> {dias === 1 ? "dia útil" : "dias úteis"} e{" "}
            <b className={falta === 0 ? "text-emerald-600" : "text-slate-800"}>{formatBRL(falta)}</b>{" "}
            {falta === 0 ? "🎯 meta batida!" : "para a meta"}
          </div>
        )}
      </div>
    </div>
  );
}
